function isViewedProperty(propertyId) {
    const viewedProperties = JSON.parse(localStorage.getItem("viewedProperties")) || [];
    if (viewedProperties.includes(propertyId)) return true; 
  
    viewedProperties.push(propertyId);
    localStorage.setItem("viewedProperties", JSON.stringify(viewedProperties));
    return false;
}

export default isViewedProperty